var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240732357,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 32626,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 108c-220 0-398.4 89.2-398.4 199.2 0 35.6 18.8 69.2 51.6 98.2l247.2 247.2V834c0 36.7 44.5 66.4 99.6 66.4 55 0 99.6-29.7 99.6-66.4V652.9l250.3-250.3c4.5-4.2 8.8-8.4 12.8-12.8l1.7-1.7c1.6-1.6 2.9-3.3 4.2-4.9 19.3-23.4 29.9-49 29.9-75.9C908.8 197.2 730.4 108 510.4 108z m0 314.3c-187.1 0-338.8-58-338.8-129.7S323.3 163 510.4 163s338.8 58 338.8 129.7-151.6 129.6-338.8 129.6z",
    fill: "#46766a",
    "p-id": 32627
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/筛选.0e1ac547dfa7fa49f78e3c5417ed2b0b.svg";
export { ForwardRef as ReactComponent };